module.exports = __webpack_public_path__ + "img/westminster_b2.adb540de.jpg";